import { PurchaseFormResponse } from '@Types/api/form';
import { MobileDrawer, ViewModal, ViewResolver } from '@Components/index';
import DetailItem from './component/DetailItem';

import styles from './view-detailes-modal.module.css';

interface ViewDetailesModalProps {
  isOpen: boolean;
  purchaseDetails: PurchaseFormResponse | undefined;
  onClose: () => void;
}

const ViewDetailesModal: React.FC<ViewDetailesModalProps> = ({
  purchaseDetails,
  isOpen,
  onClose,
}) => {
  if (!purchaseDetails) {
    return null;
  }

  return (
    <ViewResolver
      desktop={
        <ViewModal isModalOpen={isOpen} handleCancel={onClose}>
          <DetailItem purchaseDetails={purchaseDetails} />
        </ViewModal>
      }
      mobile={
        <MobileDrawer
          className={styles.mobileDrawer}
          title="Purchase Request Details"
          onClose={onClose}
          open={isOpen}
        >
          <div className={styles.mobileDrawerContainer}>
            <DetailItem purchaseDetails={purchaseDetails} />
          </div>
        </MobileDrawer>
      }
    />
  );
};

export default ViewDetailesModal;
